import { MfaBackupCodeAcknowledgement } from '@dynamic-labs/sdk-api-core';

import { getDefaultClient } from '../../../client/defaultClient';
import { updateUser } from '../../user/updateUser';

/**
 * Acknowledges that the user has viewed and saved their MFA recovery codes.
 *
 * This function marks the recovery codes as acknowledged, indicating that
 * the user has properly backed up their MFA recovery codes for account recovery.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the acknowledgment is complete.
 */
export const acknowledgeRecoveryCodes = async (client = getDefaultClient()) => {
  return updateUser(
    {
      userFields: {
        mfaBackupCodeAcknowledgement: MfaBackupCodeAcknowledgement.Complete,
      },
    },
    client
  );
};
